import type { NavItem } from './navConfig';

/**
 * The Phase-1 post-login landing target (F5-b spec FR-12): the FIRST nav entry, in list order, one of
 * whose gating permission keys the session holds (any one suffices — F3-a FR-V7) — or `null` when the
 * session holds none.
 *
 * Pure and list-order-driven on purpose. `navConfig` is authored in landing-precedence order
 * (accounts → contacts → leads → activities → email → pricing → settings), so "first accessible" is a single pass:
 * a user whose first-listed section is permission-hidden lands on the next one they can reach,
 * never the Phase-2 Dashboard (which is not a nav entry at all). Extracted as a pure helper so
 * F5-b AC-12 is a unit test rather than a router-integration-only assertion, and `null` (fail-closed,
 * F5-b NFR-4) is a value the caller renders an empty state for rather than a crash.
 */
export function resolveLanding(
    entries: readonly NavItem[],
    hasPermission: (key: string) => boolean,
): string | null {
    for (const entry of entries) {
        if (entry.permissionKeys.some(hasPermission)) {
            return entry.path;
        }
    }
    return null;
}
